import { AxiosResponse } from 'axios';
import { ModelRequest, VehicleFiltersRequest } from '@/main/models/request';
import { IModelApi } from '../base/vehicle/modelApi';
import { Result } from '../../models/common/resultResponse';
import { api } from '../base/api';
import { KeyValue } from '@/main/models/common';

const baseRoute: string = 'VehicleModel';

export class ModelApi extends IModelApi {
  getVehicleModel(
    request: ModelRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }

  getVehicleModelByFilters(
    request: VehicleFiltersRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domainbyfilters`, { params: request });
  }

  getVehicleModelByGuidCountry(
    request: ModelRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/getVehicleModelByGuidCountry`, { params: request });
  }
}
